import { styled } from 'styled-components';
import BonusTemplate from '@/shared/assets/bonus-template.svg';
import BonusTemplateActive from '@/shared/assets/bonus-template-active.svg';
import { Image } from '@/shared/ui/image';

export const BonusList = styled.div`
  display: grid;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 80px;
  grid-template-columns: repeat(4, 265px);

  @media (max-width: 900px) {
    grid-template-columns: repeat(4, 265px);
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 265px);
  }

  @media (max-width: 640px) {
    grid-template-columns: repeat(1, 1fr);
    justify-content: center;
  }
`;

export const BonusItem = styled.div`
  overflow: hidden;
  position: relative;
  min-height: 255px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  border-radius: 8px;
  background: #27262b;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    opacity: 0.4;
    border-radius: 8px;
    pointer-events: none;
    background: ${(props) => props.$generateBg};
  }

  ${({ $isActive }) =>
    $isActive &&
    `
    // box-shadow: 0px 0px 0px 2px #FFD60A;
    border-radius: 8px;
    border: 2px solid #FF9F0A;
    background: #27262B;

  `}
`;
export const CircleFirst = styled.div`
  &:before {
    content: '';
    position: absolute;
    width: 16px;
    height: 16px;
    border-radius: 1000px;
    top: 140px;
    right: -8px;
    border: 2px solid #ffd60a;
    background-color: #1b202d;
    z-index: 1;

    ${({ $isActive }) =>
      !$isActive &&
      `
      border:2px solid #1b202d;
  border-bottom:0;

  `}
  }

  &:after {
    content: '';
    position: absolute;
    width: 16px;
    height: 16px;
    border-radius: 1000px;
    top: 140px;
    left: -8px;
    border: 2px solid #ffd60a;
    background-color: #1b202d;
    z-index: 1;

    ${({ $isActive }) =>
      !$isActive &&
      `
      border:2px solid #1b202d;
  border-bottom:0;

  `}
  }
`;

export const ProviderImage = styled(Image)`
  margin: 0 auto;
`;
export const BonusImage = styled.div`
  background-image: ${(props) => `url(${props.$imageUrl})`};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  width: 100%;
  height: 140px;
  position: relative;
  z-index: 5;

  ${({ $dialogMode }) =>
    $dialogMode &&
    `
    height: 180px;
  `}

  @media (max-width: 768px) {
    background-size: cover;
  }
`;

export const BonusContent = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 16px;
  gap: 16px;
  background: #27262b;
  /* box-shadow: 0px 1px 1px 0px rgba(239, 241, 243, 0.2) inset; */
  border-radius: 8px;
`;

export const BonusTimer = styled.div`
  display: flex;
  width: auto;
  height: 26px;
  justify-content: center;
  align-items: center;
  padding: 0 8px;
  border-radius: 1000px;
  background: #131315;
  box-shadow: 0px 1px 1px 0px rgba(4, 14, 42, 0.12);
  backdrop-filter: blur(12px);
  box-shadow: 0px 1px 1px 0px rgba(4, 14, 42, 0.12);
  backdrop-filter: blur(12px);

  ${({ $isActive }) =>
    $isActive &&
    `
    background: #FDB715;
  `}
`;

export const BonusTimerWrapper = styled.div`
  display: flex;
  gap: 2px;
  position: absolute;
  top: 16px;
  left: 16px;
  z-index: 5;
`;

export const IconWrapper = styled.div`
  display: flex;
  padding: 6px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  gap: 6px;
  position: absolute;
  right: 8px;
  bottom: 8px;
  border-radius: 10px;
  background: var(--6-a-7-ba-940, rgba(106, 123, 169, 0.4));
  box-shadow:
    0px 1px 1px 0px rgba(255, 255, 255, 0.08) inset,
    0px 1px 1px 0px rgba(4, 14, 42, 0.12);
  backdrop-filter: blur(16px);
`;

export const BonusTemplateImage = styled(BonusTemplate)`
  position: absolute;
  bottom: -10px;
  left: -2px;
`;

export const BonusTemplateImageActive = styled(BonusTemplateActive)`
  position: absolute;
  bottom: -12.5px;
  left: -2px;

  &:before {
    content: '';
    position: absolute;
    width: 50px;
    height: 50px;
    left: 0;
    top: 0;
    background: red;
    border-radius: 50%;
    z-index: 1;
  }
`;

export const BonusDialogContent = styled.div`
  position: relative;
  width: 364px;
  border: 1px solid var(--2-c-344-a-40, #131315);
  background: #131315;
  overflow: hidden;

  @media (max-width: 768px) {
    width: 100%;
    height: 100%;
    overflow: auto;
    border-radius: 0px;
    background: #040404;
  }
`;

export const BonusDetails = styled.div`
  display: flex;
  flex-direction: column;
  padding: 18px;
  gap: 24px;
  height: 100%;
  overflow-y: scroll;
`;

export const DescriptionWrapper = styled.div`
  @media (max-width: 768px) {
    height: auto;
    // overflow: hidden;
  }
`;

export const BonusDescriptionWrapper = styled.div`
  height: 80px;
  overflow: hidden;
  overflow-y: scroll;
  margin-top: 4px;
  margin-bottom: 16px;

  @media (max-width: 768px) {
    height: auto;
    overflow: hidden;
  }
`;

export const DetailItems = styled.div`
  display: flex;
  flex-wrap: nowrap;
  gap: 5px;
`;

export const DetailItem = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  border-radius: 5px;
  background: rgba(61, 60, 65, 0.5);
  padding: 8px 4px;
  justify-content: center;
  align-items: center;
  gap: 4px;

  ${({ $fill }) =>
    $fill &&
    `
      flex-basis: 100%;
  `}
`;

export const BurnWarningWrapper = styled.div`
  background-color: #321d26;
  position: relative;
  padding: 20px;
  display: flex;
  justify-content: center;
  width: 80px;
  margin: 0 auto;
  border-radius: 50%;
`;

export const GamesWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 155px);
  gap: 12px;
  margin-top: 8px;
  padding-bottom: 16px;
  position:relative;
  z-index: 5;

  ${({ $centered }) =>
    $centered &&
    `
      grid-template-columns: repeat(1, 169px);
      justify-content:center;

  `}

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 115px);
    ${({ $centered }) =>
      $centered &&
      `
      grid-template-columns: repeat(1, 115px);
      justify-content:center;

  `}
`;

export const BonusInfoIcon = styled.div`
  display: flex;
  width: 40px;
  height: 40px;
  justify-content: center;
  justify-items: center;
  align-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 8px;
  background-color: #3d3c41;
`;
